import Vue from 'vue'
import VueRouter from 'vue-router'

import Main from '@/views/Main'
import Inicio from '@/views/Inicio.vue'
import Consultas from '@/views/Consultas.vue'
import Login from '@/views/Login.vue'
import Assets from '@/views/Assets.vue'
import Vehiculos from '@/views/Vehiculos.vue'
import Usuarios from '@/views/Usuarios.vue'

import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Main,
    children: [
      {
        path: '',
        name: 'Inicio',
        component: Inicio,
      },
      {
        path: 'consultas',
        name: 'Consultas',
        component: Consultas,
      },
      {
        path: 'assets',
        name: 'Assets',
        component: Assets,
      },
      {
        path: 'vehiculos',
        name: 'Vehiculos',
        component: Vehiculos,
      },
      {
        path: 'usuarios',
        name: 'Usuarios',
        component: Usuarios,
      },
    ],
    beforeEnter: (to, from, next) => {
      if (store.getters['login/isLogged']) next()
      else {
        next({ name: 'login' })
      }
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
]

const router = new VueRouter({
  // routes
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  },
})

export default router
